module.exports = require("@material-ui/icons/Person");